import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import KeyTagPairing from '../../views/keyTagPairing/KeyTagPairing';
const paths = ['location.tags', 'location.tags.tag', 'company.tags', 'company.locations.tags', 'location.keys.key', 'location.keys', 'company.keys', 'company.locations.keys', 'location.vehicles.keys', 'company.locations.vehicles.keys'];
const objectTypes = ['key', 'tag'];
export default {
  id: 'recovr.key.pairing',
  name: 'Pair Tag To Key',
  layout: {
    sectionName: 'Pairing'
  },
  matches: [{
    client: ['GroupScreen', 'ItemInfoScreen', 'DataCardDetail'],
    use: 'actionBar',
    path: paths,
    objectType: objectTypes
  }, {
    use: 'contextMenu',
    path: paths,
    objectType: objectTypes
    // usedIn : '!toolbar'
  }, {
    client: 'Main',
    use: 'headerOptions'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: 'contextMenu'
  }],
  prepare: async cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    if (delegate.relationship.isItem) {
      return GlobalState.dispatch(delegate.parent().requestCanCreate());
    }
    return GlobalState.dispatch(delegate.requestCanCreate());
  },
  isPrepared: cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    if (delegate.relationship.isItem) {
      return delegate.parent().canCreate(undefined, undefined, undefined, false) != null;
    }
    return delegate.canCreate(undefined, undefined, undefined, false) != null;
  },
  handles: cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const rel = clientProps?.relationship || clientState?.actionsContext?.clientProps?.relationship;
    if (!paths.includes(rel?.path)) {
      return false;
    }
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    let can;
    if (delegate.relationship.isItem) {
      can = delegate.parent().canCreate();
    } else {
      can = delegate.canCreate();
    }
    if (can !== true) {
      return false;
    }
    const targets = Context.getTargets(cxt);
    return targets && (!targets.length || targets.length === 1);
  },
  appearance: ({
    context
  }) => {
    return {
      name: 'Pair Tag to Key',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/pair_action_icon.png'
    };
  },
  perform: props => {
    const {
      context
    } = props;
    const {
      clientProps
    } = context;
    const {
      delegate,
      parentItem
    } = clientProps;
    const companyId = parentItem?.data?.data?.company?.id;
    const systemId = parentItem?.data?.systemId;
    Dialogs.show({
      id: 'key-tag-pair',
      component: KeyTagPairing,
      props: {
        ...props,
        delegate,
        companyId,
        systemId
      }
    });
  }
};